import i18n from "../../i18n";
import { LOCALES } from "@/enums/locales";

const locale = localStorage.getItem("locale");

if (locale) {
    i18n.locale = LOCALES[locale];
} else {
    i18n.locale = LOCALES["pt_pt"];
}

var daysV2 = new Array(31).fill().map((e, i) => {
    return { value: i + 1, text: (i + 1).toString() };
});

daysV2 = [
    {
        value: -1,
        text: i18n.t('pages.SimulatorPage.vehicleInfo.plateDropdown.plateDay'),
        disabled: true,
    },
    ...daysV2,
];

var monthsV2 = new Array(12).fill().map((e, i) => {
    return { value: i + 1, text: (i + 1).toString() };
});

monthsV2 = [
    {
        value: -1,
        text: i18n.t('pages.SimulatorPage.vehicleInfo.plateDropdown.plateMonth'),
        disabled: true,
    },
    ...monthsV2,
];

const currentYear = new Date().getFullYear();

const rangeV2 = (start, stop, step) =>
    Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
    ).map((e, i) => {
        return { value: i + 1, text: (currentYear - i).toString() };
    });

var yearsV2 = rangeV2(currentYear, currentYear - 19, -1);
yearsV2 = [{
    value: -1,
    text: i18n.t('pages.SimulatorPage.vehicleInfo.plateDropdown.plateYear'),
    disabled: true,
}, ...yearsV2];

const modalityV2 = [
    {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
    },
];

const modalityNrV2 = [
    {
        value: 1,
        text: "0",
    },
    {
        value: 2,
        text: "1",
    },
    {
        value: 3,
        text: "2",
    },
    {
        value: 4,
        text: "3",
    },
    {
        value: 5,
        text: "4",
    },
];

const credityAssurance = [
    {
        value: -1,
        text: i18n.t('dropdownSelection'),
        disabled: true,
    },
];

const credityAssuranceNr = [
    {
        value: 1,
        text: "0",
    },
    {
        value: 2,
        text: "1",
    },
];

export { yearsV2, monthsV2, daysV2, modalityV2, modalityNrV2, credityAssurance, credityAssuranceNr };